import { DateFilterType, DateType } from '../../../../../types';

import { UniversalFilterDateIsAfterModeOptions } from './components/UniversalFilterDateIsAfterMode';
import { UniversalFilterDateIsBeforeModeOptions } from './components/UniversalFilterDateIsBeforeMode';
import { UniversalFilterDateIsModeOptions } from './components/UniversalFilterDateIsMode';
import { UniversalFilterDateIsOnOrAfterModeOptions } from './components/UniversalFilterDateIsOnOrAfterMode';
import { UniversalFilterDateIsOnOrBeforeModeOptions } from './components/UniversalFilterDateIsOnOrBeforeMode';
import { UniversalFilterDateIsWithinModeOptions } from './components/UniversalFilterDateIsWithinMode';

export const enum UniversalFilterDateModes {
  IS = 'is',
  IS_WITHIN = 'is_within',
  IS_BEFORE = 'is_before',
  IS_AFTER = 'is_after',
  IS_ON_OR_BEFORE = 'is_on_or_before',
  IS_ON_OR_AFTER = 'is_on_or_after',
  // IS_NOT = 'is_not',
  IS_EMPTY = 'is_empty',
  IS_NOT_EMPTY = 'is_not_empty'
}

export type UniversalFilterDateOptions =
  | UniversalFilterDateIsAfterModeOptions
  | UniversalFilterDateIsBeforeModeOptions
  | UniversalFilterDateIsModeOptions
  | UniversalFilterDateIsOnOrAfterModeOptions
  | UniversalFilterDateIsOnOrBeforeModeOptions
  | UniversalFilterDateIsWithinModeOptions;

export type UniversalFilterDateValue = DateFilterType;

export type UniversalFilterDateFilterState = {
  mode: UniversalFilterDateModes;
  option?: UniversalFilterDateOptions;
  optionDays?: number;
  optionDate?: DateType;
};

export type UniversalFilterDateOnFilterStateChange = (
  state: UniversalFilterDateFilterState
) => void;

export type UniversalFilterDateOnChange = (
  value?: UniversalFilterDateValue
) => void;
